import { render, staticRenderFns } from "./catalog-search-result.vue?vue&type=template&id=387dffd6&scoped=true"
import script from "./catalog-search-result.vue?vue&type=script&lang=js"
export * from "./catalog-search-result.vue?vue&type=script&lang=js"
import style0 from "./catalog-search-result.vue?vue&type=style&index=0&id=387dffd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dffd6",
  null
  
)

export default component.exports